var module = angular.module('bbl.services.simpleshare');

function chunk(arr, n) {
  return arr.reduce(function(p, cur, i) {
    (p[i/n|0] = p[i/n|0] || []).push(cur);
    return p;
  },[]);
}

module.factory('simpleSlides', ['SLIDESHARE_SIGNAL_HOST', 'connect', 'pubsub', '$http', '$q', function(SLIDESHARE_SIGNAL_HOST, connect, pubsub, $http, $q) {
  var types = {
    CONNECTED: 'smpl.slides.connected',
    DISCONNECTED: 'smpl.slides.disconnected',
    ONLOAD: 'smpl.slides.onload',
    ONCHANGESLIDE: 'smpl.slides.onchangeslide',
    ONDRAWUPDATE: 'smpl.slides.ondrawupdate',
  };

  var dataChannels = {};

  return function(user, room) {
    if (dataChannels[room]) {
      return dataChannels[room];
    }

    var conn = connect(room, user),
      selfId = conn.id,
      peerCh = {},
      slideData,
      currentSlide = -1,
      drawPoints,
      isPresenting = false;

    conn.createDataChannel(room+'-slides')
      .on('channel:opened:'+room+'-slides', onPeerConnected)
      .on('channel:closed:'+room+'-slides', onPeerDisconnected);

    function onPeerConnected(id, dc) {
      (peerCh[id] = dc).onmessage = onPeerMessage;
      pubsub.pub(types.CONNECTED, conn.peers.get(id).data.user);

      if (isPresenting && slideData) {
        setTimeout(function() {
          __send('load', slideData, id);
          __send('change', currentSlide, id);
          __send('draw', drawPoints, id);
        }, 750);
      }
      // if (currentSlide === -1) {
      //   fetchData();
      // }
    }

    function onPeerDisconnected(id) {
      peerCh[id] = undefined;
      pubsub.pub(types.DISCONNECTED, conn.peers.get(id).data.user);
    }

    function onPeerMessage(evt) {
      var data = JSON.parse(evt.data);
console.info('-slides-', 'onPeerMessage', data);

      if(data.type === 'load') {
        pubsub.pub(types.ONLOAD, data.data);
      }

      if (data.type === 'change') {
        currentSlide = data.data;
        pubsub.pub(types.ONCHANGESLIDE, data.data);
      }

      if (data.type === 'draw') {
        pubsub.pub(types.ONDRAWUPDATE, data.data);
      }

      // if (data.type === 'fetch' && isPresenting && slideData) {
      //   __send('load', slideData, data.peerId);
      //   __send('change', currentSlide, data.peerId);
      //   __send('draw', drawPoints, data.peerId);
      // }
    }

    function fetchData() {
      return __send('fetch', {});
    }

    function loadSlideData(data) {
      if (data && data.path) {
        data.path = SLIDESHARE_SIGNAL_HOST + '/slides/' + data.path + '/';
      }

      slideData = data;
      console.log(slideData);

      onPeerMessage({data: __send('load', slideData)});
    }

    function changeSlide(slide) {
      if (isPresenting) {
        onPeerMessage({data: __send('change', slide)});
      }
    }

    function draw(points) {
      if (isPresenting) {
        drawPoints = points;
        __send('draw', points);
      }
    }

    function __send(type, data, peerId) {
      var msg = JSON.stringify({type: type, data: data, peerId: selfId, targetId: peerId});

      if(!peerId) {
        conn.peers.keys()
          .filter(function(peer) { return Boolean(peerCh[peer]) && peer !== selfId; })
          .forEach(function(peer) {
            try {peerCh[peer].send(msg);} catch(e) {
              console.warn('peer invalid state, cant send message!');
            }
          });
      } else {
        peerCh[peerId].send(msg);
      }

      return msg;
    }

    function uploadFile(file) {
      var data = new FormData();
      data.append('file', file);
      var defer = $q.defer();
      $http({
        method: 'POST',
        data: data,
        url: SLIDESHARE_SIGNAL_HOST+'/convert/',
        headers: {'Content-Type': undefined},
        uploadEventHandlers: { progress: function(e) {
          defer.notify(e.loaded * 100 / e.total);
        }},
      }).then(defer.resolve.bind(defer), defer.reject.bind(defer));
      defer.promise.then(function(r) {
        loadSlideData(r.data);
      });

      return defer.promise;
    }

    function getPreviousSlides() {
      var slideName = room.replace(/[\/\.]/g, '-')+'-slideshare';
      return $http.get(SLIDESHARE_SIGNAL_HOST+'/convert/'+slideName)
        .then(function(r) { return r.data; });
    }

    function clearSlideData() {
      var slideName = room.replace(/[\/\.]/g, '-')+'-slideshare';
      return $http.delete(SLIDESHARE_SIGNAL_HOST+'/convert/'+slideName);
    }

    return (dataChannels[room] = {
      upload: uploadFile,
      getPreviousSlides: getPreviousSlides,
      changeSlide: changeSlide,
      draw: draw,
      sub: pubsub.sub.bind(pubsub),
      types: types,
      loadSlideData: loadSlideData,
      clearSlideData: clearSlideData,
      setAsPresenter: function() {
        console.log('slides-', 'set as presenter', selfId);

        isPresenting = true;
      }
    });
  };
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/simpleshare/slideshare.service.js
 ** module id = 226
 ** module chunks = 0
 **/